"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SectionHeading = function (_a) {
    var className = _a.className, heading = _a.heading, subHeading = _a.subHeading;
    return (react_1.default.createElement("div", { className: className },
        subHeading && react_1.default.createElement("h4", { className: "font-medium" }, subHeading),
        react_1.default.createElement("h3", { className: "font-semibold text-lg" }, heading)));
};
exports.default = SectionHeading;
//# sourceMappingURL=index.js.map